export const ALARM_SETTINGS = [
  {
    alarmType: "VOLTAGE",
    alarmTypeId: "1A421D24-17AD-4FC7-9F6D-55300ED34965",
    settings: [
      {
        name: "above",
        value: "Above Voltage Alarm",
        desc: "Trigger alarm if the voltage is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Voltage Alarm",
        desc: "Trigger alarm if the voltage is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Voltage Alarm",
        desc:
          "Trigger alarm if the voltage is with in the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Voltage Alarm",
        desc:
          "Trigger alarm if the voltage is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "CURRENT",
    alarmTypeId: "8B1FB3E1-E9A9-4281-B638-7ED3C20AF85C",
    settings: [
      {
        name: "above",
        value: "Above Current Alarm",
        desc: "Trigger alarm if the current is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Current Alarm",
        desc: "Trigger alarm if the current is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Current Alarm",
        desc:
          "Trigger alarm if the current is with in the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Current Alarm",
        desc:
          "Trigger alarm if the current is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "TEMPERATURE",
    alarmTypeId: "7CBFAD56-7A43-4B74-8B1B-1A3A3FB6AAA8",
    settings: [
      {
        name: "above",
        value: "Above Temperature Alarm",
        desc:
          "Trigger alarm if the temperature is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Temperature Alarm",
        desc:
          "Trigger alarm if the temperature is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Temperature Alarm",
        desc:
          "Trigger alarm if the temperature is within the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Temperature Alarm",
        desc:
          "Trigger alarm if the temperature is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "THERMAL_IMAGE_MIN_TEMPERATURE",
    alarmTypeId: "2B5D4043-5542-4779-B11D-BC4A4C6FA932",
    settings: [
      {
        name: "above",
        value: "Above Thermal Image Min Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image min temperature is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Thermal Image Min Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image min temperature is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Thermal Image Min Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image min temperature is within the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Thermal Image Min Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image min temperature is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "THERMAL_IMAGE_MAX_TEMPERATURE",
    alarmTypeId: "3DDC3648-5E50-45C8-9EE5-BA03B8B298CD",
    settings: [
      {
        name: "above",
        value: "Above Thermal Image Max Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image max temperature is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Thermal Image Max Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image max temperature is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Thermal Image Max Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image max temperature is within the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Thermal Image Max Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image max temperature is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "THERMAL_IMAGE_CENTER_POINT_TEMPERATURE",
    alarmTypeId: "C694C702-252E-40DB-A1D4-6DCCA7654D70",
    settings: [
      {
        name: "above",
        value: "Above Thermal Image Center Point Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image center point temperature is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Thermal Image Center Point Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image center point temperature is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Thermal Image Center Point Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image center point temperature is with in the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Thermal Image Center Point Temperature Alarm",
        desc:
          "Trigger alarm if the thermal image center point temperature is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "ACTIVE_POWER",
    alarmTypeId: "E1B122AD-EB55-421A-85C3-403FBD57FCA1",
    settings: [
      {
        name: "above",
        value: "Above Active Power Alarm",
        desc:
          "Trigger alarm if the active power is above the defined threshold.",
        alarmType: 3,
      },
    ],
  },
  {
    alarmType: "THD_V",
    alarmTypeId: "64734C33-0D8A-4599-824B-84729DECF6F1",
    settings: [
      {
        name: "above",
        value: "Above THD - V Alarm",
        desc: "Trigger alarm if the thd - v is above the defined threshold.",
        alarmType: 3,
      },
    ],
  },
  {
    alarmType: "THD_A",
    alarmTypeId: "1BC21E3B-1A82-4D60-BDB1-E43592D7999B",
    settings: [
      {
        name: "above",
        value: "Above THD - A Alarm",
        desc: "Trigger alarm if the thd - a is above the defined threshold.",
        alarmType: 3,
      },
    ],
  },
  {
    alarmType: "POWER_FACTOR",
    alarmTypeId: "38DAF09E-17ED-45B9-9146-DEF434BF82B2",
    settings: [
      {
        name: "above",
        value: "Above Power Factor Alarm",
        desc:
          "Trigger alarm if the power factor is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Power Factor Alarm",
        desc:
          "Trigger alarm if the power factor is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Power Factor Alarm",
        desc:
          "Trigger alarm if the power factor is with in the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Power Factor Alarm",
        desc:
          "Trigger alarm if the power factor is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "FREQUENCY",
    alarmTypeId: "5A0BAE50-582B-4B2E-8338-C2A045D8D5F8",
    settings: [
      {
        name: "above",
        value: "Above Frequency Alarm",
        desc: "Trigger alarm if the frequency is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Frequency Alarm",
        desc: "Trigger alarm if the frequency is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Frequency Alarm",
        desc:
          "Trigger alarm if the frequency is with in the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Frequency Alarm",
        desc:
          "Trigger alarm if the frequency is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
  {
    alarmType: "VIBRATION",
    alarmTypeId: "8317C61C-0BCB-45CE-92AC-C1778077DE76",
    settings: [
      {
        name: "above",
        value: "Above Vibration Alarm",
        desc: "Trigger alarm if the vibration is above the defined threshold.",
        alarmType: 3,
      },
      {
        name: "below",
        value: "Below Vibration Alarm",
        desc: "Trigger alarm if the vibration is below the defined threshold.",
        alarmType: 1,
      },
      {
        name: "within",
        value: "Within Range Vibration Alarm",
        desc:
          "Trigger alarm if the vibration is within the range of the defined threshold.",
        alarmType: 2,
      },
      {
        name: "out",
        value: "Out of Range Vibration Alarm",
        desc:
          "Trigger alarm if the vibration is out of range the defined threshold.",
        alarmType: 4,
      },
    ],
  },
];

export const NOTIFICATION_UNITS = [
  {
    name: "VAC",
    value: "V AC",
    unitId: "C7001B2D-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "1A421D24-17AD-4FC7-9F6D-55300ED34965",
  },
  {
    name: "VDC",
    value: "V DC",
    unitId: "C7001B37-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "1A421D24-17AD-4FC7-9F6D-55300ED34965",
  },
  {
    name: "ADC",
    value: "A DC",
    unitId: "C7001BA4-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "8B1FB3E1-E9A9-4281-B638-7ED3C20AF85C",
  },
  {
    name: "AAC",
    value: "A AC",
    unitId: "C7001B41-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "8B1FB3E1-E9A9-4281-B638-7ED3C20AF85C",
  },
  {
    unitId: "C7001ABE-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "7CBFAD56-7A43-4B74-8B1B-1A3A3FB6AAA8",
    name: "C",
    value: "°C",
  },
  {
    unitId: "C7001AE6-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "7CBFAD56-7A43-4B74-8B1B-1A3A3FB6AAA8",
    name: "F",
    value: "°F",
  },
  {
    name: "kW",
    value: "kW",
    unitId: "5f56c4ce-1044-11e3-b325-4eb9b35797f1",
    alarmTypeId: "E1B122AD-EB55-421A-85C3-403FBD57FCA1",
  },
  {
    name: "%",
    value: "%",
    unitId: "5f56c564-1044-11e3-b325-4eb9b35797f1",
    alarmTypeId: "64734C33-0D8A-4599-824B-84729DECF6F1",
  },
  {
    name: "%",
    value: "%",
    unitId: "5f56c564-1044-11e3-b325-4eb9b35797f2",
    alarmTypeId: "1BC21E3B-1A82-4D60-BDB1-E43592D7999B",
  },
  {
    name: "Hz",
    value: "Hz",
    unitId: "C70025EB-BC55-11E2-9678-15B654818C3B",
    alarmTypeId: "5A0BAE50-582B-4B2E-8338-C2A045D8D5F8",
  },
  {
    name: "ins",
    value: "in/s",
    unitId: "e90987f0-6090-4918-9ee2-ec8cff0bad5d",
    alarmTypeId: "8317C61C-0BCB-45CE-92AC-C1778077DE76",
  },
  {
    name: "g",
    value: "g",
    unitId: "4c2f2813-02e7-4a19-a483-0ad08c7d5b22",
    alarmTypeId: "8317C61C-0BCB-45CE-92AC-C1778077DE76",
  },
  {
    name: "mms",
    value: "mm/s",
    unitId: "c50a543c-e0a4-42d4-8b45-839aa3e185c4",
    alarmTypeId: "8317C61C-0BCB-45CE-92AC-C1778077DE76",
  },
];

//utility function for rounding off values based on alarmType

export const ROUND_OFF_VALUE = (alarmTypeId, triggeredValue) => {
  switch (alarmTypeId) {
    case "7CBFAD56-7A43-4B74-8B1B-1A3A3FB6AAA8":
      return triggeredValue.toFixed(1);

    case "8317c61c-0bcb-45ce-92ac-c1778077de76":
      return triggeredValue.toFixed(3);

    default:
      return triggeredValue.toFixed(2);
  }
};

//utility function for Formatting date according to createdDate

export const FORMAT_DATE = (createdDate) => {
  const date = new Date(createdDate);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const formattedDateTime = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  return formattedDateTime;
};

//utility function for severity color based on severity admin's description.

export const SEVERITY_COLOR = (adminDesc) => {
  switch (adminDesc) {
    case "Good":
      return {
        backgroundColor: "#00ff001a",
        borderColor: "#00ff00",
      };
    case "Satisfactory":
      return {
        backgroundColor: "#ffc5391a",
        borderColor: "#ffc539",
      };
    case "Unsatisfactory":
      return {
        backgroundColor: "#ffa5001a",
        borderColor: "#ffa500",
      };
    case "Unacceptable":
      return {
        backgroundColor: "#e251531a",
        borderColor: "#E03D3D",
      };
    case "Unassigned":
      return {
        backgroundColor: "#cccccc1a",
        borderColor: "#cccccc",
      };

    default:
      break;
  }
};

// utility function for alert description.

export const ALERT_DESC_HEADER = (alarmType, low, high, notificationUnit) => {
  switch (alarmType) {
    case 1:
      return `( <${low} ${notificationUnit} )`;

    case 2:
      return `( >${low} ${notificationUnit} and <${high} ${notificationUnit} )`;

    case 3:
      return `( >${high} ${notificationUnit} )`;

    case 4:
      return `( <${low} ${notificationUnit} and >${high} ${notificationUnit} )`;

    default:
      break;
  }
};

// constants for filters in notificationList

export const DURATION_MILLISECOND_LIST = [
  { label: "1 hour", value: 3600000 },
  { label: "3 hours", value: 10800000 },
  { label: "6 hours", value: 21600000 },
  { label: "1 day", value: 86400000 },
  { label: "3 days", value: 259200000 },
  { label: "1 week", value: 604800000 },
  { label: "2 weeks", value: 1209600000 },
  { label: "1 month", value: 2592000000 },
  { label: "All", value: 0 },
];

export const FILTER_LIST = [
  { label: "All", value: "all" },
  { label: "Alarms only", value: "alarms" },
  { label: "Alerts Only", value: "alerts" },
  { label: "Other Notifications", value: "others" },
];